import { REQUIREMENT_DONUT_SIZE } from "../constants";
import { ObligationDonutSvg } from "./requirementIntelligenceDonutSvg";
import type { DonutSlice } from "./utilities";
import { OBLIGATION_STRENGTH_COPY } from "./utilities";

export function ObligationDonut({
    slices,
    total,
}: {
    slices: DonutSlice[];
    total: number;
}) {
    return (
        <div
            className="relative flex items-center justify-center"
            style={{ width: REQUIREMENT_DONUT_SIZE, height: REQUIREMENT_DONUT_SIZE }}
        >
            <ObligationDonutSvg slices={slices} total={total} />
            <div className="absolute inset-0 flex flex-col items-center justify-center">
                <div className="text-4xl font-bold text-foreground tabular-nums">
                    {total}
                </div>
                <div className="mt-1 text-[10px] tracking-wide text-muted-foreground">
                    {OBLIGATION_STRENGTH_COPY.totalLabel}
                </div>
            </div>
        </div>
    );
}
